import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en';
import zh from './zh';
import es from './es';
import fr from './fr';
import pt from './pt';
import de from './de';
import it from './it';
import ru from './ru';
import ja from './ja';
import ko from './ko';
import vi from './vi';
import tr from './tr';
import ar from './ar';

Vue.use(VueI18n);

const STORAGE_KEY = 'portal_lang';

/** 获取可用语言列表（语言切换器使用） */
export const languages = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'pt', label: 'Português', flag: '🇵🇹' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  { code: 'ja', label: '日本語', flag: '🇯🇵' },
  { code: 'ko', label: '한국어', flag: '🇰🇷' },
  { code: 'vi', label: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'tr', label: 'Türkçe', flag: '🇹🇷' },
  { code: 'ar', label: 'العربية', flag: '🇸🇦' }
];

/** RTL 语言集合 */
const RTL_LOCALES = ['ar', 'he', 'fa', 'ur'];

const messages = { en, zh, es, fr, pt, de, it, ru, ja, ko, vi, tr, ar };

/** 浏览器语言 → locale code 映射前缀 */
const BROWSER_PREFIXES = [
  ['zh', 'zh'], ['es', 'es'], ['fr', 'fr'], ['pt', 'pt'], ['de', 'de'],
  ['it', 'it'], ['ru', 'ru'], ['ja', 'ja'], ['ko', 'ko'], ['vi', 'vi'],
  ['tr', 'tr'], ['ar', 'ar']
];

/** 读取持久化的语言（localStorage > 浏览器语言 > 默认 en） */
export function detectLocale() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved && messages[saved]) return saved;
  const browser = (navigator.language || 'en').toLowerCase();
  for (let i = 0; i < BROWSER_PREFIXES.length; i++) {
    if (browser.startsWith(BROWSER_PREFIXES[i][0])) return BROWSER_PREFIXES[i][1];
  }
  return 'en';
}

const i18n = new VueI18n({
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true
});

/** 应用文本方向（RTL 语言切 dir=rtl） */
function applyDirection(code) {
  const isRtl = RTL_LOCALES.indexOf(code) !== -1;
  document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  document.documentElement.lang = code;
}

/** 切换语言并持久化 */
export function setLocale(code) {
  if (!messages[code]) return;
  i18n.locale = code;
  try { localStorage.setItem(STORAGE_KEY, code); } catch (e) {}
  applyDirection(code);
}

// 初始化 html lang / dir 属性
applyDirection(i18n.locale);

export default i18n;
